<div class="app-main__inner">

    <!-- Page header -->
    <div class="app-page-title mb-3">
        <div class="page-title-wrapper">
            <div class="page-title-heading">
                <div class="page-title-icon">
                    <i class="pe-7s-users icon-gradient bg-mean-fruit"></i>
                </div>
                <div>
                    User Master
                    <div class="page-title-subheading">Manage internal employees and external contacts for WhatsApp campaigns.</div>
                </div>
            </div>
            <div class="page-title-actions d-flex gap-2 flex-wrap">
                <button class="btn btn-outline-secondary btn-sm" (click)="downloadTemplate()"
                    [disabled]="isDownloadingTemplate || isLoadingGroups"
                    title="Download Excel template with dropdown validations">
                    <span *ngIf="isDownloadingTemplate" class="spinner-border spinner-border-sm me-1"></span>
                    ⬇ Download Template
                </button>
                <button class="btn btn-outline-primary btn-sm"
                    (click)="fileInputRef?.nativeElement?.click()" [disabled]="isUploading"
                    title="Upload filled Excel template to bulk-import users">
                    <span *ngIf="isUploading" class="spinner-border spinner-border-sm me-1"></span>
                    ⬆ Upload Excel
                </button>
                <input #fileInput type="file" accept=".xlsx" style="display:none"
                    (change)="uploadExcel($event)" />
                <button class="btn btn-primary btn-sm" (click)="openAdd()">
                    <i class="pe-7s-plus me-1"></i> Add User
                </button>
            </div>
        </div>
    </div>

    <!-- Upload result -->
    <div *ngIf="uploadSummary" class="alert alert-dismissible mb-3"
        [class.alert-success]="!uploadSummary.errors.length"
        [class.alert-warning]="uploadSummary.errors.length > 0">
        ✅ {{ uploadSummary.inserted }} user(s) imported successfully.
        <span *ngIf="uploadSummary.errors.length"> &nbsp;⚠️ {{ uploadSummary.errors.length }} row(s) had errors:</span>
        <ul *ngIf="uploadSummary.errors.length" class="mb-0 mt-1 small">
            <li *ngFor="let e of uploadSummary.errors">Row {{ e.row }}: {{ e.message }}</li>
        </ul>
        <button type="button" class="btn-close" (click)="uploadSummary = null"></button>
    </div>

    <!-- User table -->
    <div class="card" style="width: 76vw;">
        <div class="card-body p-0">
            <div *ngIf="isLoadingUsers" class="text-center py-5 text-muted">
                <span class="spinner-border spinner-border-sm me-2"></span> Loading users...
            </div>
            <div style="overflow-x: auto;">
                <vio-table-v2
                    *ngIf="!isLoadingUsers"
                    [tableData]="users"
                    [tableConfig]="tableConfig">
                </vio-table-v2>
            </div>
        </div>
    </div>

</div>

<!-- ── Add User Modal ──────────────────────────────────────────────────────── -->
<div #addModal class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"><i class="pe-7s-add-user me-2"></i>Add User</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="addError" class="alert alert-danger py-2 small">{{ addError }}</div>

                <!-- Name row -->
                <div class="row g-2 mb-3">
                    <div class="col-md-4">
                        <label class="form-label fw-semibold">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newUser.firstName" placeholder="First name" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold">Middle Name</label>
                        <input type="text" class="form-control" [(ngModel)]="newUser.middleName" placeholder="Middle name" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold">Last Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="newUser.lastName" placeholder="Last name" />
                    </div>
                </div>

                <!-- WhatsApp -->
                <div class="mb-3">
                    <label class="form-label fw-semibold">Mobile No (WhatsApp) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="newUser.whatsAppNo" placeholder="e.g. 919876543210" />
                </div>

                <!-- User Type -->
                <div class="mb-3">
                    <label class="form-label fw-semibold d-block">User Type <span class="text-danger">*</span></label>
                    <div class="d-flex gap-4">
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="addTypeExternal" name="addUserType"
                                [(ngModel)]="newUser.userType" value="external" (change)="onAddUserTypeChange()" />
                            <label class="form-check-label" for="addTypeExternal">External</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="addTypeInternal" name="addUserType"
                                [(ngModel)]="newUser.userType" value="internal" (change)="onAddUserTypeChange()" />
                            <label class="form-check-label" for="addTypeInternal">Internal (Employee)</label>
                        </div>
                    </div>
                </div>

                <!-- Organisation Name -->
                <div class="mb-3">
                    <label class="form-label fw-semibold">Organisation Name</label>
                    <input type="text" class="form-control" [(ngModel)]="newUser.organisationName" placeholder="e.g. Acme Pvt. Ltd." />
                </div>

                <!-- Stop Messages -->
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="addStopMsg" [(ngModel)]="newUser.stopMsg" />
                    <label class="form-check-label" for="addStopMsg">Stop Messages</label>
                </div>

                <!-- Internal-only: Employee Details -->
                <ng-container *ngIf="newUser.userType === 'internal'">
                    <hr class="my-3" />
                    <p class="text-muted small fw-semibold mb-3">EMPLOYEE DETAILS</p>
                    <div class="row g-2 mb-3">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Employee No. <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="newUser.empNo" placeholder="e.g. EMP001" />
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">ESI No.</label>
                            <input type="text" class="form-control" [(ngModel)]="newUser.esiNo" placeholder="ESI number" />
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Date of Birth</label>
                        <input type="date" class="form-control" [(ngModel)]="newUser.dob" />
                    </div>
                </ng-container>

                <!-- Group assignments (custom masters) -->
                <ng-container *ngIf="!isLoadingGroups && addGroups.length > 0">
                    <hr class="my-3" />
                    <p class="text-muted small fw-semibold mb-2">GROUP ASSIGNMENTS</p>
                    <div *ngFor="let group of addGroups" class="mb-3">
                        <label class="form-label fw-semibold">{{ group.master.masterName }}</label>
                        <select class="form-select" [(ngModel)]="group.selectedId">
                            <option value="">— None —</option>
                            <option *ngFor="let v of group.values" [value]="v._id">{{ v.value }}</option>
                        </select>
                    </div>
                </ng-container>
                <div *ngIf="isLoadingGroups" class="text-muted small">
                    <span class="spinner-border spinner-border-sm me-1"></span> Loading groups...
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-primary btn-sm" (click)="saveUser()" [disabled]="isSavingAdd">
                    <span *ngIf="isSavingAdd" class="spinner-border spinner-border-sm me-1"></span>
                    Save
                </button>
            </div>
        </div>
    </div>
</div>

<!-- ── Edit User Modal ─────────────────────────────────────────────────────── -->
<div #editModal class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"><i class="pe-7s-edit me-2"></i>Edit User</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="editError" class="alert alert-danger py-2 small">{{ editError }}</div>

                <!-- Name row -->
                <div class="row g-2 mb-3">
                    <div class="col-md-4">
                        <label class="form-label fw-semibold">First Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="editUser.firstName" placeholder="First name" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold">Middle Name</label>
                        <input type="text" class="form-control" [(ngModel)]="editUser.middleName" placeholder="Middle name" />
                    </div>
                    <div class="col-md-4">
                        <label class="form-label fw-semibold">Last Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" [(ngModel)]="editUser.lastName" placeholder="Last name" />
                    </div>
                </div>

                <!-- WhatsApp -->
                <div class="mb-3">
                    <label class="form-label fw-semibold">Mobile No (WhatsApp) <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="editUser.whatsAppNo" placeholder="e.g. 919876543210" />
                </div>

                <!-- User Type -->
                <div class="mb-3">
                    <label class="form-label fw-semibold d-block">User Type <span class="text-danger">*</span></label>
                    <div class="d-flex gap-4">
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="editTypeExternal" name="editUserType"
                                [(ngModel)]="editUser.userType" value="external" (change)="onEditUserTypeChange()" />
                            <label class="form-check-label" for="editTypeExternal">External</label>
                        </div>
                        <div class="form-check">
                            <input type="radio" class="form-check-input" id="editTypeInternal" name="editUserType"
                                [(ngModel)]="editUser.userType" value="internal" (change)="onEditUserTypeChange()" />
                            <label class="form-check-label" for="editTypeInternal">Internal (Employee)</label>
                        </div>
                    </div>
                </div>

                <!-- Organisation Name -->
                <div class="mb-3">
                    <label class="form-label fw-semibold">Organisation Name</label>
                    <input type="text" class="form-control" [(ngModel)]="editUser.organisationName" placeholder="e.g. Acme Pvt. Ltd." />
                </div>

                <!-- Stop Messages -->
                <div class="mb-3 form-check">
                    <input type="checkbox" class="form-check-input" id="editStopMsg" [(ngModel)]="editUser.stopMsg" />
                    <label class="form-check-label" for="editStopMsg">Stop Messages</label>
                </div>

                <!-- Internal-only: Employee Details -->
                <ng-container *ngIf="editUser.userType === 'internal'">
                    <hr class="my-3" />
                    <p class="text-muted small fw-semibold mb-3">EMPLOYEE DETAILS</p>
                    <div class="row g-2 mb-3">
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">Employee No. <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" [(ngModel)]="editUser.empNo"
                                [readonly]="!!editUser.empNo" placeholder="e.g. EMP001" />
                            <div *ngIf="editUser.empNo" class="form-text text-muted">
                                Employee No. can't be changed — pay slips are linked to it.
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label fw-semibold">ESI No.</label>
                            <input type="text" class="form-control" [(ngModel)]="editUser.esiNo" placeholder="ESI number" />
                        </div>
                    </div>
                    <div class="mb-3">
                        <label class="form-label fw-semibold">Date of Birth</label>
                        <input type="date" class="form-control" [(ngModel)]="editUser.dob" />
                    </div>
                </ng-container>

                <!-- Group assignments -->
                <ng-container *ngIf="editGroups.length > 0">
                    <hr class="my-3" />
                    <p class="text-muted small fw-semibold mb-2">GROUP ASSIGNMENTS</p>
                    <div *ngFor="let group of editGroups" class="mb-3">
                        <label class="form-label fw-semibold">{{ group.master.masterName }}</label>
                        <select class="form-select" [(ngModel)]="group.selectedId">
                            <option value="">— None —</option>
                            <option *ngFor="let v of group.values" [value]="v._id">{{ v.value }}</option>
                        </select>
                    </div>
                </ng-container>
                <div *ngIf="editGroups.length === 0" class="text-muted small">
                    No custom masters configured. Go to <strong>Masters → Custom Masters</strong> to create groups.
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-primary btn-sm" (click)="updateUser()" [disabled]="isSavingEdit">
                    <span *ngIf="isSavingEdit" class="spinner-border spinner-border-sm me-1"></span>
                    Update
                </button>
            </div>
        </div>
    </div>
</div>

<!-- ── Pay Slips Modal ─────────────────────────────────────────────────────── -->
<div #payslipModal class="modal fade" tabindex="-1" style="width: 76vw !important;">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title"><i class="pe-7s-file me-2"></i>Pay Slips — {{ payslipTitle }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="payslipError" class="alert alert-danger py-2 small">{{ payslipError }}</div>
                <div *ngIf="isLoadingPayslips" class="text-center py-4 text-muted">
                    <span class="spinner-border spinner-border-sm me-2"></span> Loading pay slips...
                </div>
                <div *ngIf="!isLoadingPayslips && !employeePayslips.length && !payslipError"
                    class="text-center py-4 text-muted">
                    No pay slips found for this employee.
                </div>
                <vio-table-v2
                style="width: 76vw !important;"
                    *ngIf="!isLoadingPayslips && employeePayslips.length"
                    [tableData]="employeePayslips"
                    [tableConfig]="payslipTableConfig">
                </vio-table-v2>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>

<!-- ── Credentials Modal ───────────────────────────────────────────────────── -->
<div #credentialsModal class="modal fade" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">🔑 Set Login — {{ credUser.name }}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div *ngIf="credError" class="alert alert-danger py-2 small">{{ credError }}</div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Username <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" [(ngModel)]="credForm.userName"
                        placeholder="e.g. john.doe or EMP001" autocomplete="off" />
                </div>
                <div class="mb-3">
                    <label class="form-label fw-semibold">Password <span class="text-danger">*</span></label>
                    <div class="input-group">
                        <input [type]="credForm.showPwd ? 'text' : 'password'" class="form-control"
                            [(ngModel)]="credForm.pwd" placeholder="Set a password"
                            autocomplete="new-password" />
                        <button class="btn btn-outline-secondary" type="button"
                            (click)="credForm.showPwd = !credForm.showPwd">
                            {{ credForm.showPwd ? 'Hide' : 'Show' }}
                        </button>
                    </div>
                </div>
                <div class="alert alert-info py-2 small">
                    Role is automatically set to <strong>employee</strong>.
                    The user can log in to the HR Portal with these credentials.
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn btn-secondary btn-sm" data-bs-dismiss="modal">Cancel</button>
                <button class="btn btn-primary btn-sm" (click)="saveCredentials()" [disabled]="isSavingCred">
                    <span *ngIf="isSavingCred" class="spinner-border spinner-border-sm me-1"></span>
                    Save Credentials
                </button>
            </div>
        </div>
    </div>
</div>
